import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cba49e92"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-filter fas" }, null, -1))
const _hoisted_2 = { class: "header-filter" }
const _hoisted_3 = { class: "table-wrapper" }

import { onMounted, ref, reactive } from "vue";
import { getSamplingPointsImageStatus } from "@/service/samplingPointImageStatus.service.ts";
import samplingPointList from "@/components/issueMonitoring/samplingPointList.component.vue";
import { SamplingPointImageStatus, IssueType, IssueSubType } from "@/types/issueMonitoring.type.ts";
import { getIssueType } from "@/service/issueType.service.ts";
import { Filter } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";
import { useRouter } from "vue-router";
import { SamplingPoint } from "@/types/samplingpoint.type";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const samplingPointListStatus = ref<Pagination<SamplingPointImageStatus>>(
  {} as Pagination<SamplingPointImageStatus>
);

const visibleSearch = ref(false);
const issueType = ref<IssueType>([]);
const points = ref<Array<SamplingPoint>>([]);
const router = useRouter();
const filters = reactive({
  filterType: {} as IssueType,
  filterSubType: {} as IssueSubType,
  point: {} as SamplingPoint,
  camera: "" as string,
  status: "" as string,
});

onMounted(async () => {
  // - Puntos de monitorización
  await searchFilter();
  if (samplingPointListStatus.value.data) {
    samplingPointListStatus.value.data.forEach((_) => {
      const index = points.value.findIndex((element) => element.code === _.samplingPoint?.code);
      if (index < 0) {
        points.value.push(_.samplingPoint ?? ({} as SamplingPoint));
      }
    });
  }

  // - Tipos de incidencias
  const filterIssue: Filter = {
    fields: {
      stationOperation: { operator: "equal", value: true },
    },
  };
  issueType.value = await getIssueType(undefined, undefined, filterIssue);
});

const updateFilter = () => {
  filters.filterSubType = {} as IssueSubType;
};

const goBack = () => {
  router.go(-1);
};
//- METHODS

/**
 * Obtener todos los puntos que se quieren monitorizar
 */
const searchFilter = async () => {
  const fields: Record<string, any> = {};

  if (filters?.filterType?.id) {
    fields["lastIssue.type"] = {
      operator: "equal",
      value: filters.filterType.id,
    };
  }

  if (filters?.filterSubType?.id) {
    fields["lastIssue.subType"] = {
      operator: "equal",
      value: filters.filterSubType.id,
    };
  }

  fields["samplingpointimagestatus.stationOperation"] = {
    operator: "equal",
    value: true,
  };

  if (filters.point.name) {
    fields["samplingPoint.name"] = {
      operator: "equal",
      value: filters.point.name,
    };
  }

  if (filters.camera) {
    fields["samplingpointimagestatus.camera"] = {
      operator: "equal",
      value: filters.camera,
    };
  }

  if (filters.status) {
    fields["samplingpointimagestatus.status"] = {
      operator: "equal",
      value: filters.status,
    };
  }
  const filter: Filter = { fields };
  samplingPointListStatus.value = await getSamplingPointsImageStatus(undefined, undefined, filter);
  // const data: SamplingPointImageStatus[] = [];
  // console.log(samplingPointListStatus.value.data);
  // for (let index of samplingPointListStatus.value.data) {
  //   data.push(samplingPointListStatus.value.data[index]);
  // }
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, {
      class: "header-import page-title",
      style: {"margin-bottom":"5px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          title: _ctx.$t('placeholder.goBack'),
          onBack: goBack,
          class: "header"
        }, {
          content: _withCtx(() => [
            _createVNode(_component_el_row, { class: "header-issue" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("label.issue_point")), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_popover, {
                    placement: "bottom",
                    width: 250,
                    visible: visibleSearch.value,
                    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((visibleSearch).value = $event))
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleSearch.value = !visibleSearch.value))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("label.issueDescription")), 1),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(filters).filterType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters).filterType) = $event)),
                        "value-key": "name",
                        class: "select-filter",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (updateFilter())),
                        filterable: "",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issueType.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.name,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(filters).filterSubType,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).filterSubType) = $event)),
                        class: "select-filter",
                        "value-key": "name",
                        filterable: "",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters).filterType?.subTypes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.name,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("label.samplingPoint")), 1),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(filters).point,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).point) = $event)),
                        filterable: "",
                        class: "select-filter",
                        "value-key": "name",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(points.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item.name,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(filters).camera,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filters).camera) = $event)),
                        placeholder: "Selecciona una opción",
                        class: "full-width",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "RGB",
                            value: "RGB"
                          }),
                          _createVNode(_component_el_option, {
                            label: "RGB-F",
                            value: "RGB-F"
                          }),
                          _createVNode(_component_el_option, {
                            label: "RGB-SF",
                            value: "RGB-SF"
                          }),
                          _createVNode(_component_el_option, {
                            label: "IR",
                            value: "IN"
                          }),
                          _createVNode(_component_el_option, {
                            label: "UV",
                            value: "UV"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("label.status")), 1),
                      _createVNode(_component_el_select, {
                        modelValue: _unref(filters).status,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filters).status) = $event)),
                        placeholder: "Estado",
                        class: "full-width",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "ERROR",
                            value: "ERROR"
                          }),
                          _createVNode(_component_el_option, {
                            label: "OK",
                            value: "OK"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_button, {
                        class: "header-filter",
                        type: "primary",
                        onClick: searchFilter
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("btn.search")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "card-issue" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(samplingPointList, { pagination: samplingPointListStatus.value }, null, 8, ["pagination"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})